export default "__VITE_ASSET__Boz0Qnxh__"